export default __webpack_public_path__ + "static/media/receipt-1-1.0b29f510.svg";